import React from 'react';

const Payment = () => {
    return (
        <div className='payment'>

        </div>
    );
};

export default Payment;
